import { Modal, DatePicker, Checkbox, InputNumber, Form, message, Button } from "antd";
import { useState, useEffect } from "react";
import { serverFetch } from "../../server";
import { CloseOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { isMobile } from "../../extensions/design";
import { strDate2Server } from "../../extensions/utils"
import { CLIENT_NESTED_ANTD_MODAL_Z_INDEX } from "./client-nested-modal-zindex";

const FreezeModal = ({ onClose, saleId }) => {
  const [form] = Form.useForm();
  const [date, setStartDate] = useState(null);
  const [noEndDate, setNoEndDate] = useState(false);
  const [dateEnd, setEndDate] = useState(null);
  const [days, setDays] = useState(null);
  const [loading, setLoading] = useState(false);
  const [minDays, setMinDays] = useState(null)
  const [maxDays, setMaxDays] = useState(null);
  useEffect(() => {
      const today = dayjs();
      setStartDate(today);
      setEndDate(today);
      form.setFieldsValue({ dateStart: today, dateEnd: today });
      getProductFreezeDays();
  }, []);

  const getProductFreezeDays = () => {
    if(Array.isArray(saleId)) return;
    setLoading(true);
    serverFetch(`sale/${saleId}`, {
      method: "GET",
    })
      .then((data) => {
        serverFetch(`product/${data.productId}`, {
          method: "GET",
        })
          .then((data) => {
            setMinDays(data.freezMin);
            setMaxDays(data.freezSrok);
            setLoading(false);
          })
          .catch((e) => {
            setLoading(false);
            message.error(e.userMessage);
          })
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(() => {
    if (date && dateEnd && !noEndDate) {
      const diff = dateEnd.startOf('day').diff(date.startOf('day'), "day");
      const value = diff > 0 ? diff : 0;
      setDays(value);
      form.setFieldsValue({ daysFreezed: value });
    }
  }, [date, dateEnd, noEndDate]);


  const onStatusUnfrozen = () => {
    const values = form.getFieldsValue();
    const dateStr = strDate2Server(values.dateStart)
    const dateEndStr = strDate2Server(values.dateEnd)
    const bodyData = Array.isArray(saleId)
      ? { saleIds: saleId, date: dateStr, dateEnd: dateEndStr }
      : { saleId, date: dateStr, dateEnd: dateEndStr };
    setLoading(true);
    serverFetch("sale/SetFrozen", {
      method: "POST",
      bodyData,
    })
      .then((res) => {
        setLoading(false);
        const payload = res?.errors ?? res?.results ?? res;
        onClose(true, payload);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  return !isMobile ? 
    <Modal
      title="Заморозить абонемент"
      open
      zIndex={CLIENT_NESTED_ANTD_MODAL_Z_INDEX}
      onCancel={() => onClose(false)}
      onOk={onStatusUnfrozen}
      okText="Сохранить"
      cancelText="Закрыть"
      width={400}
    >
      <Form form={form} colon={false} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }}>
        <div style={{ marginLeft: 30, marginBottom: 20 }}>
          <Form.Item label="Начало заморозки" name="dateStart" labelCol={{ span: 12 }}>
            <DatePicker
              value={date}
              onChange={(d) => { setStartDate(d); form.setFieldsValue({ dateStart: d }); }}
              style={{ width: "100%" }}
              format="DD.MM.YYYY"
            />
          </Form.Item>
          <Form.Item label=" " labelCol={{ span: 1 }}>
            <Checkbox checked={noEndDate} onChange={(e) => setNoEndDate(e.target.checked)}>
              Срок окончания неизвестен
            </Checkbox>
          </Form.Item>
        </div>

        {!noEndDate && (
          <>
            <Form.Item label="Окончание заморозки" name="dateEnd" labelCol={{ span: 13 }}>
              <DatePicker
                value={dateEnd}
                onChange={(d) => { setEndDate(d); form.setFieldsValue({ dateEnd: d }); }}
                style={{ width: "100%" }}
                format="DD.MM.YYYY"
              />
            </Form.Item>
            <Form.Item label="Кол-во дней заморозки" name="daysFreezed" labelCol={{ span: 13 }}>
              <InputNumber
                value={days}
                onChange={(value) => {
                  setDays(value);
                  const newDateEnd = date ? dayjs(date).add(value, 'day') : null;
                  setEndDate(newDateEnd);
                  form.setFieldsValue({ dateEnd: newDateEnd, daysFreezed: value });
                }}
                min={minDays}
                max={maxDays}
                style={{ width: "80px" }}
              />
            </Form.Item>
          </>
        )}

        <div style={{ marginTop: 20 }}>
          <Form.Item label="Общий срок с учетом текущей" labelCol={{ span: 17 }}>{days}</Form.Item>
          <Form.Item label="Минимальный срок по абонементу" labelCol={{ span: 19 }}>{minDays}</Form.Item>
          <Form.Item label="Максимальный срок по абонементу" labelCol={{ span: 19 }}> {maxDays}</Form.Item>
        </div>
      </Form>
    </Modal>
  : <div className="sport-modal">
  <div className="sport-modal-overlay">
    <div className="sport-modal-content">
      <div className="sport-modal-title">
        <span>Заморозить абонемент</span>
        <CloseOutlined className="sport-section-title-close client-close-outlined-button-style" onClick={() => onClose(false)}/>
      </div>

      <Form labelCol={{ xs: 10}} wrapperCol={{ xs: 14}} form={form} colon={false} layout="inline" className="client-abon-form-item">
        <Form.Item label="Начало заморозки" name="dateStart" className="client-abon-form-item">
          <DatePicker value={date} format="DD.MM.YYYY" className="client-abon-form-item"
            onChange={(d) => {
              setStartDate(d);
              form.setFieldsValue({ dateStart: d });
            }}
          />
        </Form.Item>
        <Form.Item label="Срок оконч. неизв." className="client-abon-form-item">
          <Checkbox checked={noEndDate} onChange={(e) => setNoEndDate(e.target.checked)}/>
        </Form.Item>
        {!noEndDate && (
          <>
            <Form.Item label="Оконч. заморозки" name="dateEnd" className="client-abon-form-item">
              <DatePicker value={dateEnd} format="DD.MM.YYYY" className="client-abon-form-item"
                onChange={(d) => {
                  setEndDate(d);
                  form.setFieldsValue({ dateEnd: d });
                }}
              />
            </Form.Item>

            <Form.Item label="Кол-во дней замор." name="daysFreezed" className="client-abon-form-item-with-margin">
              <InputNumber value={days} min={minDays} max={maxDays} className="client-abon-form-item"
                onChange={(value) => {
                  setDays(value);
                  const newDateEnd = date ? dayjs(date).add(value, "day") : null;
                  setEndDate(newDateEnd);
                  form.setFieldsValue({
                    dateEnd: newDateEnd,
                    daysFreezed: value,
                  });
                }}
              />
            </Form.Item>
          </>
        )}
        <Form.Item label="Общий срок: " className="client-abon-form-item"> <div> {days}</div></Form.Item>
        <Form.Item label="Минимальный срок: " className="client-abon-form-item"> <div> {minDays}</div></Form.Item>
        <Form.Item label="Максимальный срок: " className="client-abon-form-item"> <div> {maxDays}</div></Form.Item>
        <Button className="client-abon-form-item-with-margin" onClick={onStatusUnfrozen} loading={loading}> Сохранить </Button>
      </Form>
    </div>
  </div>
</div>
};

export default FreezeModal;